import { Element } from 'src/utils/helper/element'

const ScrollPagination = () => {
  let _o = {
    onDocEnd: null,
    detectMargin: 50,
    state: 'idle',
    context: window || null,
    onBottom: null,
    atBottom: false
  }
  return {
    set (options) {
      _o = Object.assign(_o, options)
      if (_o.context) {
        _o.context.addEventListener('scroll', this.onScroll.bind(this))
      }
    },
    loading () {
      _o.state = 'loading'
    },
    idle () {
      _o.state = 'idle'
    },
    isLoading () {
      return _o.state === 'loading'
    },
    isIdle () {
      return _o.state === 'idle'
    },
    remove () {
      if (_o.context) {
        _o.context.removeEventListener('scroll', this.onScroll.bind(this))
      }
    },
    onScroll (e) {
      /**
       * When arriving at bottom of container, call onDocEnd.
       */
      if (
        _o.onDocEnd &&
        this.isIdle() &&
        this.getScrollTop(e.target) >= (this.getHiddenHeight(e.target) - _o.detectMargin)
      ) {
        _o.onDocEnd.call()
      }
      /**
       * When atBottom changes, call onBottom.
       */
      if (_o.onBottom) {
        const isBottom = this.getScrollTop(e.target) === this.getHiddenHeight(e.target)
        if (_o.atBottom !== isBottom) {
          _o.onBottom(isBottom)
        }
        _o.atBottom = isBottom
      }
    },
    getScrollTop (target) {
      return _o.context.scrollY || target.scrollTop
    },
    getHiddenHeight (target) {
      return _o.context.innerHeight
        ? this.getDocHeight() - _o.context.innerHeight
        : Element(target.children[0]).outerHeight() - Element(target).outerHeight()
    },
    getDocHeight () {
      const D = document
      return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
      )
    }
  }
}

export {
  ScrollPagination
}
